import { cloneElement, type ReactElement } from 'react'
import { Tooltip, type TooltipProps } from '@mantine/core'

export type Condition = {
  active: boolean
  label: string
}

export type ConditionTooltipProps = Omit<TooltipProps, 'label'> & {
  children: ReactElement
  conditions: Condition[]
}

export const ConditionTooltip = ({
  children,
  conditions,
  refProp,
  ...tooltipProps
}: ConditionTooltipProps): ReactElement => {
  const activeCondition = findActiveTooltip(conditions)

  if (activeCondition) {
    return (
      <Tooltip label={activeCondition.label} refProp={refProp} {...tooltipProps}>
        {cloneElement(children, {
          disabled: true,
          tooltip: undefined,
          onClick: (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault()
          },
        })}
      </Tooltip>
    )
  }

  return children
}

const findActiveTooltip = (overrides: Condition[]): Condition | undefined => {
  return overrides.find((override) => override.active)
}
